import {moneyString} from '../utils'

import {breakdownDetails as columns} from './breakdown-utils/breakdown-columns'
let breakdownDetails = columns
breakdownDetails = Object.keys(breakdownDetails).reduce((o, c)=>{
  o[c] = breakdownDetails[c].concat([
    {key: 'value', label: 'Total'}
  ])
  return o
},{})
export {breakdownDetails}
import {breakdownFormatters} from './breakdown-utils/breakdown-formatters'
export {breakdownFormatters}

function isModifiable(detail){
  return typeof(detail.method)!=='undefined'&&
  typeof(detail.modifiable)!=='undefined'&&
  typeof(detail.value)!=='undefined'
}
export function formatBreakdown(b){
  var category = b.context.addendCategory.details.id
  var fields = breakdownDetails[category]
  if(typeof(fields)==='undefined')
    fields = []

  return fields.reduce((o, c)=>{
    if(c.key === 'value'){
      o.value = b.value
      return o
    }
    if(typeof(b.details[c.key])!=='undefined'){
      var value = b.details[c.key]
      if(value===null) value = ''
      var modifiable = isModifiable(value)
      if(modifiable)
        value = value.value
    }
    else{
      var value = ''
      var modifiable = false
    }
    var formated = value
    if(typeof(breakdownFormatters[category])!=='undefined')
      if(typeof(breakdownFormatters[category][c.key])!=='undefined'){
        formated = (breakdownFormatters[category][c.key])(value)
      }
    if(typeof(c.money)!=='undefined')
      if(c.money==true)
        formated = moneyString(formated)
    if(!modifiable)
      o[c.key] = formated
    else{
      o[c.key] = formated
      //o[c.key] = _.cloneDeep(b.details[c.key])
      //o[c.key].value = formated
    }
    return o
  }, {})
}
